import { useEffect, useState } from "react";
import { getReportSubscriptions, reportSubscribe, ReportSubscription, ReportSubscriptionType, reportUnsubscribe } from "../../../api/reportsApi";
import GlobalSpinner from "../globalsSpinner/GlobalSpinner";


interface CheckedItems {
    [key: string]: boolean;
}

type ReportSubscriptionElement = {
    type: ReportSubscriptionType,
    name: string
}

const ReportSubscriptions = () => {
    let [subscriptions, setSubscriptions] = useState<ReportSubscription[]>([])
    let [checkedItems, setCheckedItems] = useState<CheckedItems>({});

    const subsElementsNetworkAndCampaign:ReportSubscriptionElement[] = [
        {name: "Yesterday" , type: ReportSubscriptionType.NetworkAndCampaignYesterday},

        {name: "Week To Date (each day except Monday)" , type: ReportSubscriptionType.NetworkAndCampaignWeekToDate},

        {name: "Last Week (On every Monday)" , type: ReportSubscriptionType.NetworkAndCampaignLastWeek},

        {name: "Last 7 Days" , type: ReportSubscriptionType.NetworkAndCampaignLast7Days},

        {name: "Last Month (On every first day of the month)" , type: ReportSubscriptionType.NetworkAndCampaignLastMonth},

        {name: "Month To Date (each day except first day of the month)" , type: ReportSubscriptionType.NetworkAndCampaignMonthToDate},
    ]

    const subsElementsAdhoc:ReportSubscriptionElement[] = [
        {name: "Yesterday" , type: ReportSubscriptionType.AdHocYesterday},

        {name: "Week To Date (each day except Monday)" , type: ReportSubscriptionType.AdHocWeekToDate},

        {name: "Last Week (On every Monday)" , type: ReportSubscriptionType.AdHocLastWeek},

        {name: "Last 7 Days" , type: ReportSubscriptionType.AdHocLast7Days},

        {name: "" , type: ReportSubscriptionType.AdHocLastMonth},

        {name: "" , type: ReportSubscriptionType.AdHocMonthToDate},
    ]

    useEffect(() => {
        async function fetchData(){
            await Promise.all([updateSubscribtions()]);

            const initialCheckedItems: CheckedItems = {};
            const subsElements = [...subsElementsNetworkAndCampaign, ...subsElementsAdhoc]
            subsElements.forEach(item => {
                let el = subscriptions.find( el => el.reportSubscriptionType === item.type)
                if(el){
                    initialCheckedItems[item.type] = true;
                } else {
                    initialCheckedItems[item.type] = false;
                }
            });
            setCheckedItems(initialCheckedItems);
        }

        fetchData();
    }, [])

    useEffect(() => {
        const initialCheckedItems: CheckedItems = {};
        const subsElements = [...subsElementsNetworkAndCampaign, ...subsElementsAdhoc]
        subsElements.forEach(item => {
            let el = subscriptions.find( el => el.reportSubscriptionType === item.type)
            if(el){
                initialCheckedItems[item.type] = true;
            } else {
                initialCheckedItems[item.type] = false;
            }
        });
        setCheckedItems(initialCheckedItems);
    }, [subscriptions])

    const updateSubscribtions = async () => {
        let res = await getReportSubscriptions()
        if(res.type === "succes") {
            setSubscriptions(res.data.items)
        }
    }

    const handleCheckboxChange = async (type: ReportSubscriptionType) => {

        let req: ReportSubscription = {
            reportSubscriptionType: type
        }
        if(checkedItems[type]){
            await reportUnsubscribe(req)
        } else {
            await reportSubscribe(req)
        }

        setCheckedItems((prev) => ({
            ...prev,
            [type]: !prev[type],
        }));

        await updateSubscribtions()
    };

    const renderSubscribtions = (items: ReportSubscriptionElement[]) => {
        return items.map( (el, i) => {
            return <div key={`${i}--${el.type}`} className="report-subscriptions__cell">
                            {
                                 el.name == "" 
                                 ? <></>
                                 : <>
                                    <span>{el.name}</span>
                                    <label htmlFor={`report-${el.type}`} className="checkbox-control">
                                        <input 
                                            id={`report-${el.type}`} 
                                            className="checkbox" 
                                            type="checkbox" 
                                            checked={!!checkedItems[el.type]}
                                            onChange={() => handleCheckboxChange(el.type)}
                                        />
                                        <span className="checkbox-bg"></span>
                                        <span className="checkbox-cursor"></span>
                                    </label>
                                 </>
                            }
                
            </div>
        })
    }

    return (
        <>
            <div className="report-subscriptions mb-30">
                <div className="report-subscriptions__block">
                    <div className="report-subscriptions__cell"><b>Network And Campaign</b></div>
                    {renderSubscribtions(subsElementsNetworkAndCampaign)}
                    <div className="report-subscriptions__cell"><b>AdHoc</b></div>
                    {renderSubscribtions(subsElementsAdhoc)}
                </div>
            </div>
        </>
    )
}

export default ReportSubscriptions